import { render, staticRenderFns } from "./expenditureSummary.vue?vue&type=template&id=682437f4&scoped=true&"
import script from "./expenditureSummary.vue?vue&type=script&lang=js&"
export * from "./expenditureSummary.vue?vue&type=script&lang=js&"
import style0 from "./expenditureSummary.vue?vue&type=style&index=0&id=682437f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682437f4",
  null
  
)

export default component.exports